import { TABLE_PAGINATION_PAGES_BUFFER_SIZE } from './TablePaginationPages.constants'

export function getPageList({ currentPage, isMobileScreenSize, pageCount }) {
  const pages = Array.from({ length: pageCount }, (v, k) => k + 1)

  if (isMobileScreenSize) {
    if (pageCount <= 5) {
      return pages
    }

    const page = parseInt(currentPage, 10)

    if (page <= 1) {
      // 1 … last
      return [1, 'next', pageCount]
    }

    if (page >= pageCount) {
      // 1 … last
      return [1, 'prev', pageCount]
    }

    if (page === 2) {
      // 1 2 … last
      return [1, 2, 'next', pageCount]
    }

    if (page === pageCount - 1) {
      // 1 … (last-1) last
      return [1, 'prev', pageCount - 1, pageCount]
    }

    // 1 … current … last (only one digit in the middle)
    return [1, 'prev', page, 'next', pageCount]
  }

  if (pageCount <= 3 + TABLE_PAGINATION_PAGES_BUFFER_SIZE * 2) {
    return pages
  }

  const list = []

  let left = Math.max(
    1,
    parseInt(currentPage) - TABLE_PAGINATION_PAGES_BUFFER_SIZE
  )
  let right = Math.min(
    parseInt(currentPage) + TABLE_PAGINATION_PAGES_BUFFER_SIZE,
    pageCount
  )

  if (parseInt(currentPage) - 1 <= TABLE_PAGINATION_PAGES_BUFFER_SIZE) {
    right = 1 + TABLE_PAGINATION_PAGES_BUFFER_SIZE * 2
  }

  if (pageCount - parseInt(currentPage) <= TABLE_PAGINATION_PAGES_BUFFER_SIZE) {
    left = pageCount - TABLE_PAGINATION_PAGES_BUFFER_SIZE * 2
  }

  for (let i = left; i <= right; i += 1) {
    list.push(i)
  }

  if (
    parseInt(currentPage) - 1 >= TABLE_PAGINATION_PAGES_BUFFER_SIZE * 2 &&
    parseInt(currentPage) !== 1 + 2
  ) {
    list.unshift('prev')
  }

  if (
    pageCount - parseInt(currentPage) >=
      TABLE_PAGINATION_PAGES_BUFFER_SIZE * 2 &&
    parseInt(currentPage) !== pageCount - 2
  ) {
    list.push('next')
  }

  if (left !== 1) {
    list.unshift(1)
  }

  if (right !== pageCount) {
    list.push(pageCount)
  }

  return list
}
